const config = require('@/utils/config')

const NODE_ENV = process.env.NODE_ENV
const { appid } = config[NODE_ENV]
import { Toast } from 'vant'
// 判断是否微信环境

export const isWXBrowser = (() => {
  const ua = window.navigator.userAgent.toLowerCase()
  return /(micromessenger|webbrowser)/g.test(ua)
})()

// 支付宝：
export function isAlipay() {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/Alipay/i) == 'alipay') {
    return true
  }
  return false
}

export const getWechatCode = () => {
  return new Promise((resolve, reject) => {
    try {
      const code = getUrlCode().code // 是否存在code
      const local = window.location.href.replace(/\?.*#/i, '#')
      // let local = 'https://********';
      if (code == null || code === '') {
        // 不存在就打开上面的地址进行授权
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
          local
        )}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
      } else {
        resolve(code)
        // 拿到code之后就要范湖给后台 让后台返回对应的account_token和openid,尽量使用account_token 这个的刷新时间是两个小时，openid暴露出来不太好,拿到token之后就处理相关的业务逻辑
      }
    } catch (error) {
      reject('error')
    }
  })
}

export const getWechatOrgCode = () => {
  return new Promise((resolve, reject) => {
    if (isWXBrowser) {
      const orgAppid = localStorage.getItem('orgAppid') // 微信APPid
      if (!orgAppid) {
        return false
      }
      const code = getUrlCode().code // 是否存在code
      const local = window.location.href.replace(/\?.*#/i, '#')
      if (code == null || code === '') {
        // 不存在就打开上面的地址进行授权
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${orgAppid}&redirect_uri=${encodeURIComponent(
          local
        )}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
      } else {
        sessionStorage.code_2 = sessionStorage.getItem('code_2') ? sessionStorage.getItem('code_2') : code
        resolve(sessionStorage.getItem('code_2'))
        // 拿到code之后就要范湖给后台 让后台返回对应的account_token和openid,尽量使用account_token 这个的刷新时间是两个小时，openid暴露出来不太好,拿到token之后就处理相关的业务逻辑
      }
    } else {
      reject('非微信环境')
    }
  })
}

// 获取url中的参数
export const getUrlParam = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  } else {
    return null
  }
}

export const getUrlCode = () => {
  // 截取url中的code方法
  var url = location.search
  var theRequest = new Object()
  if (url.indexOf('?') != -1) {
    var str = url.substr(1)
    var strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
    }
  }
  return theRequest
}
